import { createReducer } from '@reduxjs/toolkit'
import { changePeriod, loadDashboard, loadStatistics } from '../actions/dashboard';
import { IDashboardData, IDashboardInfos, IDashboardTarget, IGlobalSummary, IPortfolioSummary } from '../../models/Dashboard';

export interface DataReducer {
    portfoliosTargets: IDashboardTarget | undefined;
    portfolioCompletions: IPortfolioSummary[] | undefined;
    portfolioSummary: IDashboardInfos | undefined;
    allData : IDashboardData[] | undefined; 
    selectedPeriod: number | undefined;
    globalStatistics: IGlobalSummary | undefined;
}

const initialState: DataReducer = {
    portfoliosTargets: undefined,
    portfolioCompletions: undefined,
    portfolioSummary: undefined,
    allData: undefined,
    selectedPeriod: undefined,
    globalStatistics: undefined
}

const dataReducer = createReducer<DataReducer>(initialState, (builder) => {
    builder.addCase(loadDashboard.pending, (state) => {
        state.portfoliosTargets = undefined;
        state.portfolioCompletions = undefined;
        state.portfolioSummary = undefined;
        state.allData = undefined;
    });
    builder.addCase(loadDashboard.fulfilled, (state, action) => {
        state.allData = [...action.payload];
        state.portfoliosTargets = state.allData[state.allData.length - 1].targets;
        state.portfolioCompletions = state.allData[state.allData.length - 1].summary;
        state.portfolioSummary = state.allData[state.allData.length - 1].infos;
        state.selectedPeriod = state.allData.length - 1;
    });
    builder.addCase(changePeriod, (state, action) => {
        if (state.allData === undefined || action.payload < 0 || action.payload >= state.allData.length){
            return;
        }
        state.portfoliosTargets = state.allData[action.payload].targets;
        state.portfolioCompletions = state.allData[action.payload].summary;
        state.portfolioSummary = state.allData[action.payload].infos;
        state.selectedPeriod = action.payload;
    })

    
    builder.addCase(loadStatistics.pending, (state) => {
        state.globalStatistics = undefined;
    });
    builder.addCase(loadStatistics.fulfilled, (state, action) => {
        state.globalStatistics = action.payload;
    });
});

export default dataReducer;
